<template>
	<div class="hotel-list-item-list">
		<Loading
			v-if="loading"
			class="hotel-list-item-list__loader"
		/>
		<ul v-else>
			<li
				v-for="(item, index) in items"
				:key="index"
			>
				<HotelListItem
					:item="item"
					:item-index="index"
					:show-suns="showSuns"
					:hotel-list-type="hotelListType"
					:discount="discounts?.get(getDiscountKeyForOffer(item))"
				/>
			</li>
		</ul>
	</div>
</template>

<script lang="ts" setup>
import HotelListItem from '@lmt-rpb/HotelListItem/HotelListItem.vue';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { getUniqueKey } from '@/components/common/services/bestOfferForHotelListService';
import type { ItemType } from '@/interfaces/hotel-list-types/hotel-list-types';
import type { DiscountHotelPriceOffer } from '@/interfaces/neusta-discount-price';

const getDiscountKeyForOffer = (item: ItemType) => {
	const offerId = item.AccommodationOffer ? item.AccommodationOffer.OfferID : item.PackageOffer!.OfferID;
	const iffCode = item.Hotel.IffCode;

	return getUniqueKey({ offerId, iffCode });
};

interface Props {
	items: ItemType[];
	loading?: boolean;
	showSuns?: boolean;
	hotelListType: string;
	discounts?: Map<string, DiscountHotelPriceOffer>;
}

withDefaults(defineProps<Props>(), {
	loading: true,
	showSuns: false,
	discounts: undefined,
});
</script>

<style lang="scss" scoped>
.hotel-list-item-list {
	margin: 0 auto;
	container-type: inline-size;
	container-name: hotel_item_list;

	.hotel-list-item-list__loader {
		margin: 30rem auto;
	}

	ul {
		list-style: none;
		padding: 0;

		& > li:not(:last-child) {
			margin-bottom: 1.6rem;
		}
	}

	// This looks a bit hacky - it is! The reason we do this padding before and after the list-item is because
	// of chrome-specific behaviour in regards to how it separates elements for the print. If we dont have a
	// padding-top, part of the border of the element will be cut off, and printed on the page before (resulting in a line
	// at the bottom of that page). The border is not recognized as part of the element, so page-break doesn't respect it.
	@media print {
		ul > li {
			padding: 1.2rem 0;
			margin: 0 !important;
			width: 100%;
			&:first-child {
				padding-top: 0;
			}
			&:last-child {
				padding-bottom: 0;
			}
		}
	}
}
</style>
